import * as React from 'react';

import {CustomerMessageRoomsState} from "../../../store/customer_message_rooms_state";
import {CustomerMessageRoomState} from "../../../store/customer_message_room_state";
import CustomerMessageRoomsLeft from "./left_side/customer_message_rooms_left";
import styled, {css} from "styled-components";
import {ICustomerMessageRoomsDispatcher} from "../../../dispatcher/customer_message_rooms_dispatcher";
import {ICustomerMessageRoomDispatcher} from "../../../dispatcher/customer_message_room_dispatcher";
import CustomerMessageRoomMain from "./main/customer_message_rooms_main";
import {ConstBreakPoint, ConstColor, ConstZIndex} from "../../../../config/styles_const/styles_const";
import CustomerMessageRoomsRight from "./right/customer_message_rooms_right";
import EmptyData from "../../../common/organism/empty_data";
import {MessageRoomsEmpty} from "../../../../config/view_const/message_rooms";
import Progress from "../../../common/organism/progress";
import {IAppNotificationMessageDispatcher} from "../../../dispatcher/app_notification_message_dispatcher";
import { Contract } from 'src/domain/model/contract';

interface IProps {
    messageRoomsState: CustomerMessageRoomsState,
    messageRoomState: CustomerMessageRoomState,
    messageRoomsDispatcher: ICustomerMessageRoomsDispatcher,
    messageRoomDispatcher: ICustomerMessageRoomDispatcher,
    notificationDispatcher: IAppNotificationMessageDispatcher,
    contracts: Contract[],
    isInit: boolean,
    match: any,
}

const CustomerMessageRoomsComponent: React.FC<IProps> = (props) => {

    const {messageRoomsState,
        messageRoomState,
        messageRoomsDispatcher,
        messageRoomDispatcher,
        notificationDispatcher,
        isInit,
        contracts,
        match
    } = props;
    const {initialMessageRoom, messageRooms} = messageRoomsState;

    const {projectId, companyId} = match.params;

    const isMessageRooms = !(projectId && companyId);

    // 初期化
    if (isInit) { return <Progress canAnimation={false}/>}

    return (
        <MessageRoomsWrapper>
            {
                messageRooms.length === 0 &&
                <EmptyData
                    main={MessageRoomsEmpty.messageRoomsForCustomerMainText}
                    description={MessageRoomsEmpty.messageRoomsForCustomerDescriptionText}
                    linkUrl={`/customer/projects`}
                    btnText={MessageRoomsEmpty.messageRoomsForCustomerBtnText}
                />
            }
            {
                messageRooms.length > 0 &&
                <Wrapper>
                    <LeftWrapper isMessageRooms={isMessageRooms}>
                        <CustomerMessageRoomsLeft 
                            messageRoomsState={messageRoomsState}
                            messageRoomsDispatcher={messageRoomsDispatcher}
                            isMessageRooms={isMessageRooms}/>
                    </LeftWrapper>
                    <MainWrapper isMessageRooms={isMessageRooms}>
                        <CustomerMessageRoomMain 
                            messageRoomState={messageRoomState}
                            initialMessageRoom={initialMessageRoom}
                            messageRoomDispatcher={messageRoomDispatcher}
                            notificationDispatcher={notificationDispatcher}
                            contracts={contracts}
                            match={match}
                        />
                    </MainWrapper>
                    <RightWrapper>
                        <CustomerMessageRoomsRight messageRoomState={messageRoomState}/>
                    </RightWrapper>
                </Wrapper>
            }
        </MessageRoomsWrapper>
    )
};

export default CustomerMessageRoomsComponent;

const MessageRoomsWrapper = styled.div`
    padding-top: 10px;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        display: flex;
        flex-direction: column;
        height: calc(100vh - 60px);
    }
`

const Wrapper = styled.div`
    display: flex;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        flex-grow: 1;
        flex-basis: 0;
        overflow: hidden;
    }
`;

const LeftWrapper = styled.div<{isMessageRooms: boolean}>`  
    width: 100%;
    z-index: ${ConstZIndex.menu};
    padding-left: 10px;
    padding-right: 10px;
    ${props => !props.isMessageRooms && css`
        display: none;
    `}
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        display: block;
        overflow: auto;
        width: 300px; 
        border-right: 1px solid ${ConstColor.PlaceholderAndBorder};
    }
`

const MainWrapper = styled.div<{isMessageRooms: boolean}>`
    flex: 1;
    ${props => props.isMessageRooms && css`
        display: none;
    `}
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        display: block;
        overflow: auto;
    }
`

const RightWrapper = styled.div`
    display: none;
    border-left: 1px solid ${ConstColor.PlaceholderAndBorder};
    @media screen and (min-width: ${ConstBreakPoint.PcDeskTop}) {
        display: block;
        width: 280px;
        padding-left: 20px;
        padding-right: 20px;
        overflow: auto;
    }

`


// WEBPACK FOOTER //
// ./src/presentation/component/customer/message_rooms/customer_message_rooms.tsx